import React, { useState, useEffect, useMemo, useCallback } from "react";

import { Container, Row, Col } from "react-bootstrap";
import { MDBDataTable } from "mdbreact";
import CustomGreenButton from "../../../components/shared/custom-green-button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Skeleton from "@material-ui/lab/Skeleton";
import TableColumnDropdown from "../../../components/shared/table-column-dropdown/table-column-dropdown";

import TvIcon from "@material-ui/icons/Tv";
import PersonIcon from "@material-ui/icons/Person";
import swal from "sweetalert";
import ExcelWorkBook from "../../../components/shared/ExcelWorkBook";
import exportFromJSON from "export-from-json";

import { useQuery } from "@tanstack/react-query";
import { fetchInstitutos } from "../../../shared/fetchers/classics/institutos/verInstitutos";
import { columnasInstitutosClassics } from "../../../shared/data/columnas/classics/institutos/institutos";
import { useHistory } from "react-router-dom";

const ListaInstitutosClassics = () => {
  const {
    data: rows,
    isLoading,
    isError,
  } = useQuery(["institutosClassics"], fetchInstitutos);

  const [columns, setColumns] = useState([]);
  const history = useHistory();
  const safeRows = Array.isArray(rows) ? rows : [];

  useEffect(() => {
    let columnas = columnasInstitutosClassics;
    //Añadimos un atributo de visible a todas las columnas
    columnas.map((columna) => (columna.isVisible = true));
    setColumns(columnas);
  }, []);

  const handleViewUsuarios = useCallback(
    (instituto) => {
      if (!instituto || !Array.isArray(instituto.usuarios) || instituto.usuarios.length === 0) {
        return;
      }

      history.push("/consultas/lista-institutos/usuarios", {
        usuarios: instituto.usuarios,
        institutoNombre: instituto.nombreMostrar || instituto.nombre,
        totalUsuarios: instituto.totalUsuarios,
      });
    },
    [history]
  );

  const preparedRows = useMemo(() => {
    return safeRows.map((row) => {
      const totalUsuarios = Number(row.totalUsuarios) || 0;
      const hasUsuarios = Array.isArray(row.usuarios) && row.usuarios.length > 0 && totalUsuarios > 0;

      return {
        ...row,
        ingresoApp: row.ingresoApp ? "Si" : "No",
        usuariosAcciones: (
          <CustomGreenButton
            disabled={!hasUsuarios}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              if (hasUsuarios) {
                handleViewUsuarios(row);
              }
            }}
          >
            {hasUsuarios ? `Ver (${totalUsuarios})` : "Sin datos"}
          </CustomGreenButton>
        ),
      };
    });
  }, [safeRows, handleViewUsuarios]);

  //Funcion para cambiar el estado de visibilidad de una columna
  const changeColumnStatus = (columnField) => {
    const temp = [...columns];
    const index = temp.findIndex((column) => column.field === columnField);
    temp[index].isVisible = !temp[index].isVisible;
    setColumns(temp);
  };

  if (isLoading)
    return (
      <>
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
        <Skeleton animation="wave" />
      </>
    );

  if (isError) return <div>Ha ocurrido un error</div>;

  return (
    <>
      <div className="mb-4 d-flex align-items-center">
        <div className="admin-page-tilte">(</div>
        <TvIcon />
        <div className="admin-page-tilte mr-2">)</div>
        <div className="admin-page-tilte">Lista de Institutos</div>
      </div>
      <Container fluid>
        <Row>
          <Col xs={12} className="content-white-box px-4 py-4">
            <div className="d-flex align-items-center">
              <PersonIcon />
              <div className="admin-main-title-dark-gray ml-2 mt-1">
                Tabla de institutos
              </div>
            </div>
            <div className="admin-muted-text-small mt-1 mb-4">
              Lista de todos los institutos.
            </div>

            {/* Este componente es el dropdown que permite ocultar columnas*/}
            <TableColumnDropdown
              columns={columns}
              changeColumnStatus={changeColumnStatus}
            />
            <br />
            <ButtonGroup size="small" variant="contained" className="my-3">
              <CustomGreenButton
                onClick={() => {
                  const dat = [...safeRows];
                  navigator.clipboard
                    .writeText(JSON.stringify(dat))
                    .then(async () => {
                      await swal({
                        title: "Se ha copiado la tabla!",
                        icon: "success",
                      });
                    });
                }}
              >
                Copy
              </CustomGreenButton>

              <CustomGreenButton>
                <ExcelWorkBook
                  columns={columns}
                  rows={safeRows}
                  filename={"Lista-institutos-classics"}
                />
              </CustomGreenButton>

              <CustomGreenButton
                onClick={() => {
                  exportFromJSON({
                    data: safeRows,
                    fileName: "Lista-institutos-classics",
                    exportType: exportFromJSON.types.csv,
                  });
                }}
              >
                CSV
              </CustomGreenButton>
            </ButtonGroup>
            <MDBDataTable
              small
              responsive
              searchTop
              searchBottom={false}
              barReverse
              pagingTop
              striped
              bordered
              data={{
                columns: columns.filter((obj) => obj.isVisible),
                rows: preparedRows,
              }}
              noBottomColumns
              order={["name", "asc"]}
              entriesOptions={[5, 10, 20, 50]}
              entriesLabel="Numero de filas"
              searchLabel="Buscar"
              paginationLabel={["Anterior", "Siguiente"]}
              infoLabel={["Mostrando filas", "a", "de", "filas"]}
            />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ListaInstitutosClassics;
